const getColorByHex = hex => {
  switch (hex) {
    case '#B0BF1A': return { name: 'zielony', hex }
    case '#90EE90': return { name: 'jasny zielony', hex }
    case '#008443': return { name: 'ciemny zielony', hex }
    case '#1974D2': return { name: 'niebieski', hex }
    case '#7CB9E8': return { name: 'jasny niebieski', hex }
    case '#0048BA': return { name: 'ciemny niebieski', hex }
    case '#D92121': return { name: 'czerwony', hex }
    case '#FFCCCB': return { name: 'jasny czerwony', hex }
    case '#8B0000': return { name: 'ciemny czerwony', hex }
    case '#FADA5E': return { name: 'żółty', hex }
    case '#FFFF9F': return { name: 'jasny żółty', hex }
    case '#EEDC82': return { name: 'ciemny żółty', hex }
    case '#F64A8A': return { name: 'różowy', hex }
    case '#FFB6C1': return { name: 'jasny różowy', hex }
    case '#E75480': return { name: 'ciemny różowy', hex }
    case '#FFBF00': return { name: 'pomarańczowy', hex }
    case '#FED8B1': return { name: 'jasny pomarańczowy', hex }
    case '#FF8C00': return { name: 'ciemny pomarańczowy', hex }
    default: return { name: 'brak', hex }
  }
}

const getColorByName = name => {
  switch (name) {
    case 'zielony': return { hex: '#B0BF1A', name }
    case 'jasny zielony': return { hex: '#90EE90', name }
    case 'ciemny zielony': return { hex: '#008443', name }
    case 'niebieski': return { hex: '#1974D2', name }
    case 'jasny niebieski': return { hex: '#7CB9E8', name }
    case 'ciemny niebieski': return { hex: '#0048BA', name }
    case 'czerwony': return { hex: '#D92121', name }
    case 'jasny czerwony': return { hex: '#FFCCCB', name }
    case 'ciemny czerwony': return { hex: '#8B0000', name }
    case 'żółty': return { hex: '#FADA5E', name }
    case 'jasny żółty': return { hex: '#FFFF9F', name }
    case 'ciemny żółty': return { hex: '#EEDC82', name }
    case 'różowy': return { hex: '#F64A8A', name }
    case 'jasny różowy': return { hex: '#FFB6C1', name }
    case 'ciemny różowy': return { hex: '#E75480', name }
    case 'pomarańczowy': return { hex: '#FFBF00', name }
    case 'jasny pomarańczowy': return { hex: '#FED8B1', name }
    case 'ciemny pomarańczowy': return { hex: '#FF8C00', name }
    default: return { hex: '#CCCCCC', name }
  }
}

const indexOf = (array, obj, fn) => {
  if (!array) return -1

  if (!fn || typeof fn !== 'function') return array.indexOf(obj)

  for (let i = 0; i < array.length; i++) {
    if (fn(array[i], obj)) {
      return i
    }
  }

  return -1
}

const copyTextToClipboard = text => {
  const textArea = document.createElement("textarea")

  // Place in top-left corner of screen regardless of scroll position.
  textArea.style.position = 'fixed'
  textArea.style.top = 0
  textArea.style.left = 0

  // Ensure it has a small width and height. Setting to 1px / 1em
  // doesn't work as this gives a negative w/h on some browsers.
  textArea.style.width = '2em'
  textArea.style.height = '2em'

  // We don't need padding, reducing the size if it does flash render.
  textArea.style.padding = 0

  // Clean up any borders.
  textArea.style.border = 'none'
  textArea.style.outline = 'none'
  textArea.style.boxShadow = 'none'

  // Avoid flash of white box if rendered for any reason.
  textArea.style.background = 'transparent'

  textArea.value = text

  document.body.appendChild(textArea)

  textArea.select()

  try {
    // const successful = document.execCommand('copy')
    document.execCommand('copy')
    // const msg = successful ? 'successful' : 'unsuccessful'
    //console.log('Copying text command was ' + msg)
  } catch (err) {
    console.log('Oops, unable to copy', err)
  }

  document.body.removeChild(textArea);
}

export { getColorByHex, getColorByName, indexOf, copyTextToClipboard }
